import React, { FC } from 'react';
import { isEditorActive, Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TCHModelDetailNavigationSectionProps } from './types/productModelNavigation.types';
import { CHModelDetailNavigationSectionModel } from './models/productModelNavigation.model';
import { isEmptyResponse } from '../../utils/checkEmptyResponse';
import useExperiencerEditorPlaceholder from '../../hooks/useExperiencerEditorPlaceholder';
import ExperienceEditorComponentPlaceholder from '../@shared/experienceEditorComponentPlaceholder';
import EmptyApiDataMessage from '../@shared/emptyApiDataMessage';
import { targetLinkdsk } from '../../utils/targetDskLink';
import useMediaQuery from '../../lib/custom-hooks/useMediaQuery';
import { BreakpointsInPx } from '../../constants/breakpoints.constants';
import { NAVIGATION_BAR_LABEL } from '../../constants/navigationBar.constants';
import RoutableNotEditableLink from '../@shared/routableNotEditableLink';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { googleClickSubNavigationEvent } from '../../utils/analytics';
import IconOrImage from '../@shared/iconOrImage';
import { appendRootToInternalLink } from '../../utils/appendRootToInternalLink.utils';

const ProductModelNavigation: FC<TCHModelDetailNavigationSectionProps> = (props) => {
  const apiResponse = isEmptyResponse(props);
  const model = new CHModelDetailNavigationSectionModel(props);
  const isPlaceholderShown = useExperiencerEditorPlaceholder(props);
  const isDesktop = useMediaQuery(`(min-width: ${BreakpointsInPx['md']})`);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }

  //  star node opened directly in EE
  if (isPlaceholderShown) {
    return <ExperienceEditorComponentPlaceholder image={model.thumbnailEE} componentName={model.componentName} />;
  }

  // not opened from star node
  // data missing when navigating via from products node
  if (!apiResponse && isEditorActive()) {
    return <EmptyApiDataMessage componentName={model.componentName} />;
  }

  // No data and not in EE
  if ((!apiResponse && !isPlaceholderShown && !isEditorActive()) || model?.innerComponents?.length === 0) {
    return null;
  }

  return (
    <div className="product-model-navigation">
      {model.innerComponents.map(
        ({ button, assets }, index) =>
          button &&
          button?.label &&
          button.url && (
            <div key={`nav-${index}`} className="product-model-navigation__cta-wrapper">
              <RoutableNotEditableLink
                href={appendRootToInternalLink(button.url)}
                target={targetLinkdsk({ value: { href: button?.url, target: button?.target } }, isDesktop)}
                onClick={() => googleClickSubNavigationEvent(button?.label, NAVIGATION_BAR_LABEL)}
              >
                <div className="product-series-detail-navigation-overview__cta-icon-wrapper">
                  <IconOrImage assets={assets} />
                </div>
                <Text editable={false} field={{ value: button.label }} tag="p" className="product-model-navigation__cta-label" />
              </RoutableNotEditableLink>
            </div>
          )
      )}
    </div>
  );
};

export default withSitecoreContext()(ProductModelNavigation);
